import React, {Component} from 'react';
import Messages from 'components/molecules/message/global';
import SiteSwitch from 'components/organisms/site-switch';
import SportSwitch from 'components/organisms/sport-switch';
import GameSwitch from 'components/organisms/game-switch';
import ModeSwitch from 'components/organisms/mode-switch';
import SlateSwitch from 'components/organisms/slate-switch';
import LateSwapFileDataReceiver from 'components/organisms/late-swap/late-swap-file-data-receiver';
import OptimizationResult from 'components/organisms/late-swap/components/optimization-result';
import FilterByGames from 'components/organisms/late-swap/components/filter-by-games';
import Players from 'components/organisms/late-swap/components/players';

class LateSwapComponent extends Component {
    render() {
        return (
            <>
                <Messages />
                <div className="white-box">
                    <div className="main-filter">
                        <ModeSwitch />
                        <SiteSwitch />
                        <SportSwitch />
                        <GameSwitch />
                        <SlateSwitch />
                    </div>
                    <FilterByGames />
                </div>
                <Players />
                <LateSwapFileDataReceiver />
                <OptimizationResult />
            </>
        );
    }
}

export default LateSwapComponent;
